import { useEffect, useState } from "react";
import { getMeta } from "./api";

// Prices are charged in EUR by Stripe; the dollar figures are indicative only.
export const useUsdRate = () => {
  const [rate, setRate] = useState(1.1);
  useEffect(() => {
    getMeta()
      .then((m) => m?.limits?.usd_rate && setRate(m.limits.usd_rate))
      .catch(() => {});
  }, []);
  return rate;
};

export const fmtPrice = (eur, usd, rate) =>
  usd ? `$${(eur * rate).toFixed(2).replace(/\.00$/, "")}` : `€${eur}`;
